import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./cell-grid-selector.component.html?ngResource";
import { Component, Input, Output, EventEmitter, } from '@angular/core';
import _ from 'lodash';
import { Subject } from 'rxjs';
let CellGridSelectorComponent = class CellGridSelectorComponent {
    options = {};
    model;
    selectionChange = new EventEmitter();
    columns = [];
    rows = [];
    isDragging = false;
    static selectedClass = 'selected';
    startCell = null;
    endCell = null;
    selected = new Set();
    isSelecting = false;
    #destroy$ = new Subject();
    ngOnInit() {
        this.setupRowsAndColumns();
        this.parsePreSelected();
    }
    ngOnChanges(changes) {
        if (changes.model && !changes.model.firstChange) {
            this.clearSelection();
            this.parsePreSelected();
        }
    }
    ngOnDestroy() {
        this.#destroy$.next(null);
        this.#destroy$.complete();
    }
    setupRowsAndColumns() {
        this.rows = _.times(this.options.rows, String);
        this.columns = _.times(this.options.columns, String);
    }
    clearSelection() {
        this.selected.clear();
    }
    parsePreSelected() {
        if (!_.isEmpty(this.model)) {
            this.model.forEach(this.selected.add, this.selected);
        }
    }
    parseSelectedCells() {
        return new Set(this.selected);
    }
    notifySelectionChange() {
        this.selectionChange.emit(this.parseSelectedCells());
    }
    selectRow(row) {
        const cellsToSet = [];
        let shouldSelect = false;
        for (const col of this.columns) {
            cellsToSet.push([row, col]);
            if (!this.getCell(row, col)) {
                shouldSelect = true;
            }
        }
        cellsToSet.forEach(cell => this[shouldSelect ? 'selectCell' : 'deselectCell'](...cell));
        this.notifySelectionChange();
    }
    selectCol(col) {
        const cellsToSet = [];
        let shouldSelect = false;
        for (const row of this.rows) {
            cellsToSet.push([row, col]);
            if (!this.getCell(row, col)) {
                shouldSelect = true;
            }
        }
        cellsToSet.forEach(cell => this[shouldSelect ? 'selectCell' : 'deselectCell'](...cell));
        this.notifySelectionChange();
    }
    mousePressed($event, row, column) {
        if ($event.buttons === 1 /* Buttons.Primary */) {
            this.isDragging = true;
            this.setStartCell(row, column);
            this.setEndCell(row, column);
        }
    }
    mouseReleased(row, column) {
        if (!this.isDragging) {
            return;
        }
        this.setEndCell(row, column);
        this.endDragging();
    }
    mouseEntered(row, column) {
        if (!this.isDragging) {
            return;
        }
        this.setEndCell(row, column);
    }
    endDragging() {
        if (!(this.isDragging && this.startCell && this.endCell)) {
            return;
        }
        const topLeft = {
            column: Math.min(this.startCell.column, this.endCell.column),
            row: Math.min(this.startCell.row, this.endCell.row),
        };
        const bottomRight = {
            column: Math.max(this.startCell.column, this.endCell.column),
            row: Math.max(this.startCell.row, this.endCell.row),
        };
        for (let i = topLeft.row; i <= bottomRight.row; i++) {
            for (let j = topLeft.column; j <= bottomRight.column; j++) {
                if (this.isSelecting) {
                    this.selectCell(i, j);
                }
                else {
                    this.deselectCell(i, j);
                }
            }
        }
        this.isDragging = false;
        this.startCell = null;
        this.endCell = null;
        this.notifySelectionChange();
    }
    showDragClass(row, col) {
        if (!(this.isDragging && this.startCell && this.endCell)) {
            return '';
        }
        const { endCell: { column: endCol, row: endRow }, startCell: { column: startCol, row: startRow }, } = this;
        const rowDragDirection = startRow <= endRow ? [startRow, endRow] : [endRow, startRow];
        const colDragDirection = startCol <= endCol ? [startCol, endCol] : [endCol, startCol];
        // +1 to bypass range exclusion
        rowDragDirection[1] += 1;
        colDragDirection[1] += 1;
        const cellIncluded = _.inRange(Number(row), ...rowDragDirection) && _.inRange(Number(col), ...colDragDirection);
        return cellIncluded ?
            this.isSelecting ? 'drag-on' : 'drag-off' :
            '';
    }
    setStartCell(row, column) {
        const key = `${column}.${row}`;
        this.isSelecting = !this.selected.has(key);
        this.startCell = { row: Number(row), column: Number(column) };
    }
    setEndCell(row, column) {
        if (!this.startCell) {
            return;
        }
        this.endCell = { row: Number(row), column: Number(column) };
    }
    getCell(row, col) {
        return this.selected.has(`${col}.${row}`);
    }
    selectCell(row, col) {
        const key = `${col}.${row}`;
        this.selected.add(key);
    }
    deselectCell(row, col) {
        const key = `${col}.${row}`;
        this.selected.delete(key);
    }
    clear() {
        this.clearSelection();
        this.notifySelectionChange();
    }
    static propDecorators = {
        options: [{ type: Input }],
        model: [{ type: Input }],
        selectionChange: [{ type: Output }]
    };
};
CellGridSelectorComponent = __decorate([
    Component({
        selector: 'cell-grid-selector',
        template: __NG_CLI_RESOURCE__0,
    })
], CellGridSelectorComponent);
export { CellGridSelectorComponent };
